import { produce } from "immer";
import { GlobalActions, resetAction } from "../../globals/store/actions";
import { createEntityAdapter } from "../../helpers/store/create-entity-adapter";
import { Notification } from "../interfaces/api/get-notifications";
import {
  getNotificationsFailureAction,
  getNotificationsInitAction,
  getNotificationsSuccessAction,
  getSystemNotificationsFailureAction,
  getSystemNotificationsInitAction,
  getSystemNotificationsSuccessAction,
  NotificationApiAction,
  putReadNotificationFailureAction,
  putReadNotificationInitAction,
  putReadNotificationsFailureAction,
  putReadNotificationsInitAction,
  putReadNotificationsSuccessAction,
  putReadNotificationSuccessAction
} from "./api-actions";

export interface NotificationState {
  count: number;
  infoMessage: string | null;
  infoMessageEs: string | null;
  infoMessageEn: string | null;
  infoMessagePt: string | null;
  notifications: {
    ids: string[];
    entities: Record<string, Notification>;
  };
}

const initialState: NotificationState = {
  count: 0,
  infoMessage: null,
  infoMessageEs: null,
  infoMessageEn: null,
  infoMessagePt: null,
  notifications: {
    ids: [],
    entities: {},
  },
};

const notificationsAdapter = createEntityAdapter<Notification>(
  (payload) => payload.id
);

export default produce(
  (
    draft: NotificationState = initialState,
    action: NotificationApiAction | GlobalActions
  ) => {
    switch (action.type) {
      case getNotificationsSuccessAction.type:
        notificationsAdapter.addMany(action.notifications, draft.notifications);
        draft.count = action.count;
        return draft;
      case putReadNotificationsSuccessAction.type:
        notificationsAdapter.removeAll(draft.notifications);
        draft.count = 0;
        return draft;
      case putReadNotificationSuccessAction.type:
        notificationsAdapter.removeOne(action.id, draft.notifications);
        draft.count -= 1;
        return draft;
      case getSystemNotificationsSuccessAction.type:
        draft.infoMessage = action.infoMessage;
        draft.infoMessageEs = action.infoMessageEs;
        draft.infoMessageEn = action.infoMessageEn;
        draft.infoMessagePt = action.infoMessagePt;
        return draft;
      case resetAction.type:
        return initialState;
      case getNotificationsInitAction.type:
      case getNotificationsFailureAction.type:
      case putReadNotificationsInitAction.type:
      case putReadNotificationsFailureAction.type:
      case putReadNotificationInitAction.type:
      case putReadNotificationFailureAction.type:
      case getSystemNotificationsInitAction.type:
      case getSystemNotificationsFailureAction.type:
      default:
        return draft;
    }
  }
);
